import { css } from "styled-components";
import React from "react";
export default css`
  .ant-btn-primary.cg-resume {
    background-color: transparent;
    background-image: linear-gradient(to top, #004779, #0184c9) !important;
  }

  .ant-select-arrow {
    display: none;
    font-size: 11px;
  }
  // <-------------------antd Table ------------------->
  .ant-table-wrapper .ant-table.ant-table-small .ant-table-tbody > tr > td {
    border-bottom: 4px solid #f5f5f5;
  }
  .ant-table-wrapper .ant-table-thead > tr > th {
    border-bottom: 10px solid #f5f5f5;
    height: 56px;
  }
  .ant-table-wrapper
    .ant-table-container
    table
    > thead
    > tr:first-child
    > *:first-child {
    border-start-start-radius: 0px;
  }
  .ant-table-wrapper
    .ant-table-container
    table
    > thead
    > tr:first-child
    > *:last-child {
    border-start-end-radius: 0px;
  }
  .ant-table-wrapper .ant-table-thead {
    background-image: linear-gradient(to top, #004779, #0184c9) !important;
  }
  .ant-table-wrapper .ant-table-thead > tr > th {
    background: transparent;
    color: white;
  }

  .ant-table-wrapper .ant-table-filter-trigger {
    color: white;
  }
  .ant-table-wrapper .ant-table-tbody > tr.ant-table-row:hover {
    box-shadow: 0 0 21px 0 rgba(51, 51, 51, 0.1);
    background-color: white;
  }
  
  //<------------------ant select ----------->
  @media only screen and (max-width: 667px) {
    .ant-select-single .ant-select-selector {
      font-size: 11px;
    }
    .ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
      padding: 0px 10px;
    }
  }
`;
